<script setup>

import { watch, defineProps, defineEmits, ref, computed} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import PedidoConteudo from "./PedidoConteudo.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "visualizandoPedido",
    "controlesDesativados",
    "pedidoDeCompra"
]);

const emits = defineEmits([
    "update:visualizandoPedido",
    "update:controlesDesativados"
]);

//==================================================================//
//========================= Justificativa ==========================//
//==================================================================//

const justificativa = ref(props?.pedidoDeCompra?.justificativa);

//==================================================================//
//====================== Altera Justificativa ======================//
//==================================================================//

const alteraJustificativa = (update) =>{

    justificativa.value = update.justificativa;

};

//==================================================================//
//=================== Altera Visualizando Pedido ===================//
//==================================================================//

const alteraVisualizandoPedido = (update) =>{

    alteraJustificativa({
        justificativa: null
    });

    emits('update:visualizandoPedido',update);

};

//==================================================================//
//=================== Altera Visualizando Pedido ===================//
//==================================================================//

const alteraControlesDesativados = (update) =>{

    emits('update:controlesDesativados',update);

};

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.visualizandoPedido"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card
                class="c-modal"
                :class="{ 'c-modal--disabled': props.controlesDesativados }"
            >

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :controlesDesativados="props.controlesDesativados"
                    :pedidoDeCompra="props.pedidoDeCompra"
                    :justificativa="justificativa"
                    :visualizandoPedido="props.visualizandoPedido"
                    @update:visualizandoPedido="alteraVisualizandoPedido"
                    @update:controlesDesativados="alteraControlesDesativados"
                >
                </BarraNavegacao>

                <PedidoConteudo
                    :pedidoDeCompra="pedidoDeCompra"
                    :justificativa="justificativa"
                    :controlesDesativados="controlesDesativados"
                    @update:justificativa="alteraJustificativa"
                >
                </PedidoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

.c-modal--disabled{
    pointer-events: none;
    user-select: none; 
}

</style>

